import React from "react";
import { Button, ButtonGroup, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faUsers } from "@fortawesome/free-solid-svg-icons";
import "./ClassActionCell.css";

const ClassActionCell = props => (
  <Row style={{ display: "block" }}>
    <div className="floatRight">
      <ButtonGroup size="sm">
        <Button
          className="btn-green"
          onClick={event => {
            event.stopPropagation();
            props.onEdit();
          }}
        >
          <FontAwesomeIcon icon={faPen} size="1x" />
        </Button>

        <Button
          className="btn-black"
          onClick={event => {
            event.stopPropagation();
            props.onShowMembers();
          }}
        >
          <FontAwesomeIcon icon={faUsers} size="1x" />
        </Button>

        <Button
          className="btn-red"
          onClick={event => {
            event.stopPropagation();
            props.onDelete();
          }}
        >
          <FontAwesomeIcon icon={faTrash} size="1x" />
        </Button>
      </ButtonGroup>
    </div>
  </Row>
);

export default ClassActionCell;
